import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import EventService from "../../services/srv-event/EventService";
import { useParams } from "react-router-dom";
import { EventParticipantFields } from "../../containers/Event/Detail/EventParticipantFields";
import { EventInfoCard } from "../../containers/Event/Detail/EventInfoCard";
import { EventDatesCard } from "../../containers/Event/Detail/EventDatesCard";
import { Card, CardBody } from "@progress/kendo-react-layout";
import { CommonUploadFiles } from "../../components/sys-common/CommonFileUpload";
import { EventParticipantCard } from "../../containers/Event/Detail/EventParticipantCard";
import { Col, Row } from "reactstrap";

function EventDetail(props) {
  const { id } = useParams();
  const [selected, setSelected] = useState(0);
  const { t } = useTranslation();
  const [event, setEvent] = useState({});

  useEffect(() => {
    getEventData();
  }, []);

  function getEventData() {
    EventService.getEvent(id).then((data) => {
      setEvent(data);
    });
  }

  const handleSelect = (e) => {
    setSelected(e.selected);
  };
  return (
    <Fragment>
      <Row>
        <Col
          className="mb-3"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {event.etkinliK_TANIM_ID ? (
            <EventInfoCard event={event}></EventInfoCard>
          ) : undefined}
        </Col>
        <Col
          className="mb-3"
          lg="6"
          md="6"
          sm="12"
          xs="12"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {event.etkinliK_TANIM_ID ? (
            <EventParticipantFields event={event}></EventParticipantFields>
          ) : undefined}
        </Col>
      </Row>
      <Card>
        <CardBody style={{ padding: "5px" }}>
          <TabStrip selected={selected} onSelect={handleSelect}>
            <TabStripTab
              title={
                <span>
                  <i
                    style={{ color: "mediumblue" }}
                    className="fa fa-calendar fa-lg"
                  ></i>{" "}
                  {t("dates_of_event")}
                </span>
              }
            >
              <div>
                {event.etkinliK_TANIM_ID ? (
                  <EventDatesCard event={event} />
                ) : undefined}
              </div>
            </TabStripTab>
            <TabStripTab
              title={
                <span>
                  <i
                    style={{ color: "mediumblue" }}
                    className="fa fa-folder fa-lg"
                  ></i>{" "}
                  {t("event_files")}
                </span>
              }
            >
              {event.etkinliK_TANIM_ID ? (
                <CommonUploadFiles
                  tableName={"DKN_ETKINLIK_TANIM"}
                  tableId={event.etkinliK_TANIM_ID}
                  fileType={"ETKINLIK"}
                />
              ) : undefined}
            </TabStripTab>
            <TabStripTab
              title={
                <span>
                  <i
                    style={{ color: "mediumblue" }}
                    className="fa fa-user fa-lg"
                  ></i>{" "}
                  {t("participant_list")}
                </span>
              }
            >
              <div>
                {event.etkinliK_TANIM_ID ? (
                  <EventParticipantCard event={event} />
                ) : undefined}
              </div>
            </TabStripTab>
          </TabStrip>
        </CardBody>
      </Card>
    </Fragment>
  );
}

export { EventDetail };
